import { useSite } from "@/context/SiteContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const { settings } = useSite();
  const link = settings.whatsapp_link || "https://wa.me/447500225285";
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg wa-pulse hover:scale-105 transition-transform duration-300"
    >
      <MessageCircle size={28} fill="white" strokeWidth={0} />
    </a>
  );
}
